import { render, staticRenderFns } from "./GestionPerfil.vue?vue&type=template&id=7dd67dca&"
import script from "./GestionPerfil.vue?vue&type=script&lang=js&"
export * from "./GestionPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports